module.exports = __webpack_public_path__ + "img/individual-dashboard-slide1.1fb17acb.gif";